(function(Drupal, once) {

  Drupal.behaviors.header_navbar_search = {

    attach(context) {
      once('header-nav-search', '.header_menu__search', context)
        .forEach(el => {
          let field = el.querySelector('.form-search')
          field.setAttribute('placeholder', "Search the ASAP site...")
          let toggle = el.querySelector('.search-toggle');
          let block = el.querySelector('.search-block');
          toggle.addEventListener('click', function(e){
            if(!e.handled){
              block.classList.toggle('active');
              e.handled =  true;
            }
          })
        })
    }
  }  

  function toggleOpen(element) {
    element.getAttribute('aria-expanded') === 'true'
      ? element.setAttribute('aria-expanded', 'false')
      : element.setAttribute('aria-expanded', 'true')
  }
})(Drupal, once);
